/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import { getSpecificIcon } from '../../helpers/producttypes.js';
import LinearProgress from 'material-ui/LinearProgress';
import PropTypes from 'prop-types';

import './style.css';

class CategoryButton extends Component {
  getIcon = (name, isChecked, iconStyle) => {
    const color = isChecked ? '#7B9E4A' : '#616161';
    return getSpecificIcon(name, color, iconStyle);
  }

  getFilterNameClass = () => {
    return this.props.filterNameClass;
  }

  render() {
    const name = this.props.catName;
    if (!name) return null;
    if (this.props.isFetching && this.props.active) {
      return (
        <div style={{position: 'relative'}}>
          <div onClick={this.props.onClick} role="cat" className={`cat`}>
            { this.getIcon(name.toUpperCase(), this.props.active) }
            { name && <div className={this.getFilterNameClass()}>{name}</div> }
          </div>
          <LinearProgress className="cat-load-progress" color="#8BC027" mode="indeterminate" />
        </div>
      );
    }
    return (
      <div onClick={this.props.onClick} role="cat" className={`cat` + (this.props.active ? ` selected` : ``)}>
          { this.getIcon(name.toUpperCase(), this.props.active) }
          { name && <div className={this.getFilterNameClass()}>{name}</div> }
      </div>
    );
  }
}

CategoryButton.propTypes = {
  catName: PropTypes.string.isRequired,
  filterNameClass: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired
};

export default CategoryButton;



// WEBPACK FOOTER //
// ./src/components/CategoryButton/CategoryButton.jsx